import { BUSINESS_NAME, googleDetails } from "@/content";
import { getServiceCategories, servicesMetaTags } from "@/content/services";
import { leadGenerationServiceNavigationGroup } from "@/content/lead-generation-sydney";
import Link from "next/link";
import {PageSeo} from "@modes0/ui-components-seo";
import {seoSiteProfile} from "@/content/seo";
import {
    GoogleServiceArea,
    ServiceCategoryNavigationBlock,
    type ServiceCategoryNavigationBlockGroup,
} from "@modes0/ui-components";

const brandAccentColor = "#00970f";
const brandAccentDarkColor = "#005e0b";

const getCategoryHref = (category: ReturnType<typeof getServiceCategories>[number]) =>
    `/${category.categoryType}/${category.slug}`;

const getServicesNavigationGroups = (
    serviceCategories: ReturnType<typeof getServiceCategories>
): ServiceCategoryNavigationBlockGroup[] =>
    serviceCategories.map((category) => ({
        id: category.id,
        title: category.name,
        description: category.description?.[0],
        href: getCategoryHref(category),
        ariaLabel: `View ${category.name} services`,
        accentColor: brandAccentColor,
        items: (category.subCategories || []).map((service) => ({
            id: service.id,
            title: service.title,
            description: service.description,
            href: service.link,
            accentColor: brandAccentColor,
            accentDarkColor: brandAccentDarkColor,
            ctaLabel: `View ${service.title}`,
        })),
    }));

export default function Services() {
    const serviceCategories = getServiceCategories();
    const serviceNavigationGroups = [
        ...getServicesNavigationGroups(serviceCategories),
        {
            ...leadGenerationServiceNavigationGroup,
            accentColor: brandAccentColor,
            items: leadGenerationServiceNavigationGroup.items.map((item) => ({
                ...item,
                accentColor: brandAccentColor,
                accentDarkColor: brandAccentDarkColor,
            })),
        },
    ];

    return (
        <>
            <PageSeo meta={servicesMetaTags} siteProfile={seoSiteProfile} includeBusinessSchema />
            <header className="grow-leads-page-heading">
                <p className="grow-leads-page-heading__eyebrow">{BUSINESS_NAME}</p>
                <h1>Grow Leads Services</h1>
                <p>
                    {BUSINESS_NAME} provides fast websites, local SEO, digital setup, branding, media and marketing
                    services for Sydney businesses.
                </p>
            </header>
            <ServiceCategoryNavigationBlock
                groups={serviceNavigationGroups}
                Link={Link}
                overline={BUSINESS_NAME}
                title="Grow Leads Services"
                description={`${BUSINESS_NAME} provides fast websites, local SEO, digital setup, branding, media and marketing services for Sydney businesses.`}
                navTitle="Service categories"
                itemCtaLabel="View service"
                showItemDescriptions
                accentColor={brandAccentColor}
                backgroundColor="#ffffff"
                panelBackgroundColor="#ffffff"
                columns="auto"
                ariaLabel="Grow Leads services and categories"
            />
            <div className="py-10">
                <GoogleServiceArea googleDetails={googleDetails} />
            </div>
        </>
    );
}
